export default "__VITE_ASSET__DG8NRxEN__"